
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commerce",
      function () {
        return require("private-next-pages/commerce/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commerce"])
      });
    }
  